<template>
    <b-tabs justified content-class="mt-3" align="center" class="workHourCard" >
        <b-tab :title="$t('account.workHours.classicView')">
            <b-table-simple>
                <b-thead>
                    <b-th  v-for="field in hourField" :key="field.key" > {{field.label}} </b-th>
                    <b-th > {{$t('account.list.actions')}} </b-th>
                </b-thead>
                <b-tbody>
                    <template v-for="hour in hourList" >
                        <b-tr :key="hour.id" v-if="hour.id" > 
                            <b-td v-for="field in hourField" :key="field.key"> 
                                <span v-if="field.type == 'Bool'" >
                                    <b-icon v-if="renderDataTable(field.keys, 'array', hour)" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                </span>
                                <span v-else > {{ renderDataTable(field.keys, 'array', hour, field.type)}}</span>
                            </b-td>
                            <b-td style="display: flex; justify-content: space-evenly">
                                    <b-icon icon="pencil" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('edit',hour)"></b-icon> 
                                    <b-icon icon="files" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('copy',hour)"></b-icon> 
                                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('delete',hour)"></b-icon>

                            </b-td>
                        </b-tr>
                    </template>
                    
                </b-tbody>
            </b-table-simple>
        </b-tab>
        <b-tab :title="$t('account.workHours.advancedView')" >
                <!--componentin üsttünde hangi rengin neyi temsil etttiğini  belirten panel-->
            <div class="info" >
                <div class="hourType">
                    <b-icon icon="circle-fill" variant="success"/> {{$t('account.workHours.earlyEntryTol')}}
                    <b-icon icon="circle-fill" variant="info"/> {{$t('account.workHours.lateEntryTol')}}
                    <b-icon icon="circle-fill" class="purple"/> {{$t('account.workHours.earlyClosingTol')}}
                    <b-icon icon="circle-fill" variant="primary"/> {{$t('account.workHours.lateClosingTol')}}
                    <b-icon icon="circle-fill" variant="dark"/> {{$t('account.workHours.outOfHoursTol')}}
                    <b-icon icon="circle-fill" variant="warning"/> {{$t('account.workHours.workingHours')}}
                    <b-icon icon="circle-fill" variant="danger"/> {{$t('account.workHours.holiday')}} 
                </div>
            </div>
            <b-table-simple bordered class="workHourTbl" >
                <b-thead>
                    <b-th> Gün / Saat </b-th>
                    <b-th v-for="i in 24" :key="i"> {{i-1}} </b-th>
                </b-thead>
                <b-tbody >
                    <b-tr v-for="(day, index) in data" :key="index" @click="openModal('edit',hourList[index] )" > 
                        <b-td> 
                            <span v-b-popover.hover="popoverConfig(hourList[index])"  > 
                                {{hours[index] && hours[index].name}} 
                            </span> 
                           
                            
                        </b-td>
                        <b-td v-if="day.isClose">selam</b-td>
                        <b-td v-for="(h, hIndex) in day" :key="hIndex" :colspan="h.isClose && 24" >
                            <div class="times" v-if="h.isClose">
                                 <div class="timeQuarter danger" :title="'Tatil Günü'" > </div> 
                            </div> 
                            <div class="times" v-else >
                                <template v-for="(m, mIndex) in h">
                                    <div v-if="m.isClose" :key="mIndex"  class="timeQuarter danger" :title="m.text"> </div> 
                                    <div v-else :key="mIndex" :class="'timeQuarter '+ m.type" :title="m.text">  </div>    
                                </template>
                            </div> 
                        </b-td>
                    </b-tr>      
                </b-tbody>
            </b-table-simple>
        </b-tab>
    </b-tabs>
</template>
<script>
    window.onload = function(){
        var timeQuarter = document.getElementsByClassName('timeQuarter')
        for(var i = 0; i < timeQuarter.length; i++){
            timeQuarter[i].id = i
        }
    }      
    import i18n from '@/plugins/i18n';
    import moment from 'moment'

    let  hours = [
        {key:1, name: i18n.t('general.days.mon') },
        {key:2, name: i18n.t('general.days.tue') },
        {key:3, name: i18n.t('general.days.wed') },
        {key:4, name: i18n.t('general.days.thu') },
        {key:5, name: i18n.t('general.days.fri') },
        {key:6, name: i18n.t('general.days.sat') },
        {key:7, name: i18n.t('general.days.sun')},
    ];
    let hourField = [
            {key: "beginDay", type:'Day', label: i18n.t('account.workHours.beginDay'), keys:['begin_day_id']},
            {key: "endDay", type:'Day', label:  i18n.t('account.workHours.endDay'), keys:['end_day_id']},
            {key: "opening_time", label:  i18n.t('account.workHours.openingTime'), keys:['opening_time']},
            {key: "closing_time", label:  i18n.t('account.workHours.closingTime'), keys:['closing_time']},
            {key: "is_close", type:'Bool', label:  i18n.t('account.workHours.offDay'), keys:['is_close']},
        ]
    export default {
        name: 'WorkHour',
        data: function(){
            return {
               hours,
               tabIndex: 0,
                data:[],
                workTimes: [], 
                earlyOpn: this.hourList.length > 0 ? this.hourList[0].early_dis_tol : 0,
                earlyCls: this.hourList.length > 0 ? this.hourList[0].early_arm_tol : 0,
                lateOpn: this.hourList.length > 0 ? this.hourList[0].tardy_dis_tol : 0,
                lateCls: this.hourList.length > 0 ? this.hourList[0].tardy_arm_tol : 0,
                overTime: this.hourList.length > 0 ? this.hourList[0].non_over_time : 0,
                selecting: false,
                startIndex: null,
                endIndex: null,
                createHour: false,
                days:[i18n.t('general.days.mon'), i18n.t('general.days.tue'), i18n.t('general.days.wed'), i18n.t('general.days.thu'),
                i18n.t('general.days.fri'), i18n.t('general.days.sat'), i18n.t('general.days.sun')],
                hourField
            }
        },
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function },
            edit: Boolean,
            renderData: Boolean,
            hourList: Array,
        },
        created: async function(){
            !this.createHour && await this.createHours(this.hours)
        },
        watch: {
             hourList: async function(newVal, oldVal){
                 if(newVal !== oldVal){
                    if(newVal == null)
                        this.hourList = oldVal
                    else if(newVal.length > 0){
                        this.earlyOpn = newVal[0].early_dis_tol
                        this.earlyCls = newVal[0].early_arm_tol
                        this.lateOpn =  newVal[0].tardy_dis_tol
                        this.lateCls = newVal[0].tardy_arm_tol
                        this.overTime = newVal[0].non_over_time
                    }
                    await this.createHours()
                 }
            }
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        },
        methods: {
             renderDataTable: function(data, type, obj, fType){
                let detail;
                if(data){
                    switch(type){
                        case 'info':
                            for(let i = 0; i<data.length; i++){
                                detail = detail ? detail[data[i]] : this.accountDetail[data[i]]
                            }
                            return detail 
                        case 'array':
                            for(let i = 0; i<data.length; i++){
                                if(fType && fType=="date"){
                                    detail = detail ? moment(detail[data[i]] ).format('DD MMMM YYYY HH:mm') :
                                     moment(obj[data[i]]).format('DD MMMM YYYY HH:mm')

                                }else if(fType && fType=="Day"){
                                    detail = detail ? this.days[detail[data[i]]-1] :
                                     this.days[obj[data[i]]-1]

                                } else {
                                    detail = detail ? detail[data[i]] : obj[data[i]]
                                }
                            }
                            return detail 
                    }
                }
                
            },
            moment: function(data){
                return moment(data).format('HH:mm:ss');
            },
            createHours: function() {
                let wHours = this.$store.getters.getAccountHours ? this.$store.getters.getAccountHours : []
                let tmpWHours = [];
                
                if(wHours.length < 7){
                    let count = 7 - wHours.length;
                    for(let c = 1; c <= count; c++){
                        wHours.push({})
                    }  
                }
                this.data = []

                wHours.map((w,index) => {
                    let tmpData = [];
                    if(w.is_close){
                        tmpWHours.push({isClose: true})
                    }else{
                        let earlyOpnTolDate =  moment(w.opening_time, 'HH:mm:ss').subtract(this.earlyOpn, "minutes")
                        let workTimeStartDate = moment(w.opening_time, 'HH:mm:ss')
                        let lateOpnTolDate = moment(w.opening_time, 'HH:mm:ss').add(this.lateOpn, "minutes")
                        let isBefore = w.closing_time ? moment(w.closing_time, 'HH:mm:ss').isBefore(moment(w.opening_time)) : false
                        let workTimeEarlyTolDate =  moment(w.closing_time, 'HH:mm:ss').subtract(this.earlyCls, "minutes")
                        let workTimeEndDate =  moment(w.closing_time, 'HH:mm:ss')
                        let workTimeLateTolDate =  moment(w.closing_time, 'HH:mm:ss').add(this.lateCls, "minutes")
                        let workTimeOverTimeDate =  moment(w.closing_time, 'HH:mm:ss').add(this.lateCls+this.overTime, "minutes")

                        // Erken Açılış Toleransı
                        tmpData.push({
                            h: w.opening_time ? parseInt(earlyOpnTolDate.format('HH')) : 0,
                            m:  w.opening_time ? parseInt(earlyOpnTolDate.format('mm')) : 0 
                        })
                        // Mesai Başlangıcı
                        tmpData.push({ 
                            h: w.opening_time ? parseInt(workTimeStartDate.format('HH')) : 0,
                            m: w.opening_time ? parseInt(workTimeStartDate.format('mm')) : 0
                        })
                        // Geç Açılış Toleransı
                        tmpData.push({
                            h: w.opening_time ? parseInt(lateOpnTolDate.format('HH')) : 0,
                            m: w.opening_time ? parseInt(lateOpnTolDate.format('mm')) : 0
                        })
                        // Erken Kapanış Toleransı
                        tmpData.push({ 
                            h: isBefore ? 24 : w.opening_time ? parseInt(workTimeEarlyTolDate.format('HH')) : 0,
                            m: isBefore ? 0 :  w.opening_time ? parseInt(workTimeEarlyTolDate.format('mm')) : 0 
                        })
                        //Mesai Bitişi
                        tmpData.push({ 
                            h: w.closing_time ?  parseInt(workTimeEndDate.format('HH')) : 0,
                            m: w.closing_time ?  parseInt(workTimeEndDate.format('mm')): 0
                        })
                        //Geç Kapanış Toleransı
                        tmpData.push({ 
                            h: w.closing_time ? parseInt(workTimeLateTolDate.format('HH')) : 0,
                            m: w.closing_time  ? parseInt(workTimeLateTolDate.format('mm')) : 0
                        })
                        //Mesai Dışı Tolerans
                        tmpData.push({ 
                            h: w.closing_time ? parseInt(workTimeOverTimeDate.format('HH')) : 0,
                            m: w.closing_time ? parseInt(workTimeOverTimeDate.format('mm')) : 0
                        })
                        
                        tmpWHours.push(tmpData)
                    }
                    
                })
                this.workTimes = tmpWHours;
                this.renderHoursStyle()
                this.createHour = true
                return 0
            },
             timeIntervalTxt(i,type){
                // Saatin üzerine gelindiğinde açıklama çıksın
                let hTitle = ('0'+Math.floor(i*15/60)).slice(-2)+':'+('0'+Math.floor((i*15)%60)).slice(-2)+' - ' + ('0'+Math.floor((i+1)*15/60)).slice(-2)+':'+('0'+Math.floor(((i+1)*15)%60)).slice(-2)
               
                switch(type){
                    case 'success':
                        return i18n.t('account.workHours.earlyEntryTol') + '\n' + hTitle;
                    case 'info': 
                        return i18n.t('account.workHours.lateEntryTol') + '\n' + hTitle;
                    case 'warning': 
                        return i18n.t('account.workHours.workingHours') + '\n' + hTitle;
                    case 'purple': 
                        return i18n.t('account.workHours.earlyClosingTol') + '\n' + hTitle;
                    case 'primary': 
                        return i18n.t('account.workHours.lateClosingTol') + '\n' + hTitle;
                    case 'dark': 
                        return i18n.t('account.workHours.outOfHoursTol') + '\n' + hTitle;
                    default:
                        return hTitle
                }
             },
             renderHoursStyle(){
                let itemArr = []; //Saat başı 4 adet eleman oluşturulacak
                let item = []; // Günlük her saat için 1 eleman toplam 24 eleman olacak
                
                for(let i = 0; i < this.workTimes.length; i++){
                    itemArr = []
                    item = []
                    if(this.workTimes[i].isClose){
                        this.data.push([{isClose: true}])
                    }else{
                        let wt = this.workTimes[i]
                        //Pieces günün toleranslarla birlikte olan bölümlerini ifade etmektedir
                        //Örneğin pieces1 erken giriş, pieces2 geç giriş ....
                        let pieces1 = (wt[0].h * 4) + (wt[0].m / 15);
                        let pieces2 = (wt[1].h * 4) + (wt[1].m / 15);
                        let pieces3 = (wt[2].h * 4) + (wt[2].m / 15);
                        let pieces4 = (wt[3].h * 4) + (wt[3].m / 15);
                        let pieces5 = (wt[4].h * 4) + (wt[4].m / 15);
                        let pieces6 = (wt[5].h * 4) + (wt[5].m / 15);
                        let pieces7 = (wt[6].h * 4) + (wt[6].m / 15);
                        
                        // Bir Önceki günün mesai başlangıcı ve bitişi
                        let beforeI, bWorkStart, bWorkEnd, bPieces5, bPieces6, bPieces7 ;
                        if(i - 1 < 0)
                            beforeI = this.workTimes.length - 1;
                        else 
                            beforeI = i - 1;
                        let beforeClose = this.workTimes[beforeI].isClose
                        if(!beforeClose){
                             bWorkStart = (this.workTimes[beforeI][1].h * 4) + (this.workTimes[beforeI][1].m / 15);
                             bWorkEnd =  (this.workTimes[beforeI][3].h * 4) + (this.workTimes[beforeI][3].m / 15);
                             bPieces5 = (this.workTimes[beforeI][4].h * 4) + (this.workTimes[beforeI][4].m / 15);
                             bPieces6 = (this.workTimes[beforeI][5].h * 4) + (this.workTimes[beforeI][5].m / 15);
                             bPieces7 = (this.workTimes[beforeI][6].h * 4) + (this.workTimes[beforeI][6].m / 15);
                        }

                        for(let j = 0; j < (24 * 4); j++){
                            if(j%4 == 0 && j !== 0){
                                item.push(itemArr)
                                itemArr = []
                            }
                                if(j < pieces1){
                                    if(!beforeClose && bWorkEnd < bWorkStart){
                                        if(j< bWorkEnd){
                                            itemArr.push({type: "warning", text: this.timeIntervalTxt(j, 'warning')})
                                        }else if(j< bPieces5){
                                            itemArr.push({type: "purple", text: this.timeIntervalTxt(j, 'purple')}) 
                                        }else if(j< bPieces6){
                                            itemArr.push({type: "primary", text: this.timeIntervalTxt(j, 'primary')}) 
                                        }else if(j< bPieces7){
                                            itemArr.push({type: "dark", text: this.timeIntervalTxt(j, 'dark')}) 
                                        }else{
                                            itemArr.push({type: "default", text: this.timeIntervalTxt(j, 'default')})
                                        }
                                    }else
                                        itemArr.push({type: "default", text: this.timeIntervalTxt(j, 'default')})
                                }else if( j <  pieces2){
                                    itemArr.push({type: "success", text: this.timeIntervalTxt(j, 'success')})
                                }else if(j < pieces3){
                                    itemArr.push({type: "info", text: this.timeIntervalTxt(j, 'info')})
                                }else if(j < pieces4 || pieces4 < pieces3){
                                    itemArr.push({type: "warning", text: this.timeIntervalTxt(j, 'warning')})
                                }else if(j < pieces5){
                                    itemArr.push({type: "purple", text: this.timeIntervalTxt(j, 'purple')})
                                }else if(j < pieces6){
                                    itemArr.push({type: "primary", text: this.timeIntervalTxt(j, 'primary')})
                                }else if(j < pieces7){
                                    itemArr.push({type: "dark", text: this.timeIntervalTxt(j, 'dark')})
                                }else{
                                    itemArr.push({type: "default", text: this.timeIntervalTxt(j, 'default')})
                                }
                        }
                        item.push(itemArr)
                        itemArr = []
                        this.data.push(item)
                    }
                }
                
             },
             popoverConfig(data) {
                //Gün isminin üzerine geldiğinde ortaya çıkacak popup
                //Title fonksiyonu ile popup a title ekleyebilirsiniz
                return {
                    html: true,
                    content: () => {
                        if(data){
                            return 'Mesai Saatler: '+data.opening_time+' - '+data.closing_time+
                                '<br> ' + i18n.t('account.workHours.earlyEntryTol') + this.earlyOpn + ': dk'+
                                '<br> ' + i18n.t('account.workHours.lateEntryTol') + this.lateOpn + ': dk'+
                                '<br> ' + i18n.t('account.workHours.lateClosingTol') + this.lateCls + ': dk'+
                                '<br> ' + i18n.t('account.workHours.outOfHoursTol') + this.overTime + ': dk'
                        }
                    }
                }
            },
            openModal: function(type, data){
                this.modalType(true, 'WorkHours')
                this.modalEvent(true, type, data)
            },
        }
    }
</script>
<style lang="css" scoped>
    @import "./styles/workHour.min.css";
</style>


// WEBPACK FOOTER //
// src/components/WorkHours.vue